<div class="voice-input-container">
  
  <!-- Microphone Button -->
  <button 
    class="voice-button" 
    (click)="toggleRecording()"
    [class.recording]="isRecording"
    [disabled]="!isSupported"
    tooltip="Click to start or stop voice recording and transcription">
    <i class="position-relative" [class]="isRecording ? 'fa fa-microphone-slash' : 'fa fa-microphone'"></i>
    <span class="voice-button-text">{{ isRecording ? 'Stop' : 'Voice' }}</span>
  </button>

  <!-- Recording Status & Live Transcript -->
  <div *ngIf="isRecording" class="recording-status-container">
    <div class="recording-indicator">
      <span class="recording-dot"></span>
      Listening...
    </div>
    <div *ngIf="transcript" class="live-transcript-display">
      <p class="live-transcript-text">{{ transcript }}</p>
      <p class="transcript-hint">Say "period", "comma", "question mark", "exclamation", "semicolon", or "colon" for punctuation</p>
    </div>
  </div>

  <!-- Transcript Confirmation Card -->
  <div *ngIf="showTranscriptConfirmation && transcript" class="transcript-confirmation-card">
    <div class="confirmation-header">
      <i class="fa fa-microphone-slash text-success"></i>
      <span class="confirmation-title">Voice Transcript</span>
    </div>
    
    <div class="confirmation-content">
      <p class="transcript-text">{{ transcript }}</p>
    </div>
    
    <div class="confirmation-actions">
      <button class="btn btn-success" (click)="useTranscript()">
        <i class="fa fa-check"></i> Use This
      </button>
      <button class="btn btn-warning" (click)="reRecord()">
        <i class="fa fa-redo"></i> Re-record
      </button>
      <button class="btn btn-danger" (click)="clearAll()">
        <i class="fa fa-times"></i> Clear
      </button>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="error-message">
    <i class="fa fa-exclamation-circle"></i>
    <span>{{ error }}</span>
  </div>

  <!-- Unsupported Message -->
  <div *ngIf="!isSupported" class="unsupported-message">
    <i class="fa fa-info-circle"></i>
    <span>Voice recognition not supported. Use Chrome, Edge, or Firefox.</span>
  </div>

</div>
